import type {SupportedCurrency} from 'src/v2/state/types';
import {absurd} from 'src/utils/absurd';
import {
  apiAmountToAssetAmount,
  decimalAmountToRawAmount,
} from 'src/utils/helpers';

export type RequiredRawAmountInput =
  | {
      type: 'relayCurrency';
      relayInputAmount: string;
      selectedCurrency: SupportedCurrency;
    }
  | {
      type: 'paymentCurrency';
      amount: number;
      paymentCurrency: string;
      selectedCurrency: SupportedCurrency;
    };

export const getRequiredRawAmount = (input: RequiredRawAmountInput): bigint => {
  switch (input.type) {
    case 'relayCurrency':
      return decimalAmountToRawAmount(
        input.relayInputAmount,
        input.selectedCurrency.currencyMinorUnits,
      );
    case 'paymentCurrency':
      return apiAmountToAssetAmount(
        input.amount,
        input.paymentCurrency,
        input.selectedCurrency.currencyMinorUnits,
      );
    default:
      return absurd(input);
  }
};
